<template>
	<div>
        <div class="modal fade" id="mdBaixarTitulosReceber" role="dialog">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Baixa de títulos à receber</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-12 col-lg-12">
                                <span class="lblselect2">Filial:</span>
                                <select id="cbfilialbaixarec" v-model="vcodfilbaixa" data-placeholder="Selecionar filial" data-allow-clear="true" style="width:100%; font-weight: bold;" v-bind:disabled="parseInt(propidlancamentopdv) > 0"></select>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <label for="eddtpagamento">Dt. Pagamento</label>
                                <div class="input-group date campodata" id="eddtpagamento">
                                    <input type="text" id="eddtpagamento" v-model="vdtbaixa" class="form-control form-control-sm" disabled/>
                                    <span class="input-group-addon">
                                        <span class="glyphicon glyphicon-calendar"></span>
                                    </span>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-9 col-lg-9">
                                <label for="ednomeclientebaixa">Nome do cliente</label>
                                <input type="text" class="form-control form-control-sm" v-model="vclientebaixa" id="ednomeclientebaixa" data-bv-group=".group" maxlength="50" disabled/>
                            </div>
                            <div class="col-sm-2 col-md-3 col-lg-3">
                                <label for="edvalortotalbaixa">Total</label>
                                <money class="form-control form-control-sm" id="edvalortotaltit" v-bind="money" v-model="vvariaveisbaixarcmp.vtottitbaixa" data-bv-group=".group" style="text-align:right;" disabled></money>
                            </div>
                            <div class="col-sm-2 col-md-3 col-lg-3">
                                <label for="edtotalmultabaixa">Total multa</label>
                                <money class="form-control form-control-sm" id="edtotalmultabaixa" v-bind="money" v-model="vvariaveisbaixarcmp.vtotmultabaixa" data-bv-group=".group" style="text-align:right;" disabled></money>
                            </div>
                            <div class="col-sm-2 col-md-3 col-lg-3">
                                <label for="edpercdesctojurosbaixa">Desc. Juros(%)</label>
                                <money class="form-control form-control-sm" id="edpercdesctojurosbaixa" v-bind="money" v-model="percdescontojuros" data-bv-group=".group" style="text-align:right;"></money>
                            </div>
                            <div class="col-sm-2 col-md-3 col-lg-3">
                                <label for="edvldesctojurosbaixa">Vl. Juros</label>
                                <money class="form-control form-control-sm inputs-valores" id="edvldesctojurosbaixa" v-bind="money" v-model="valdescontojuros" data-bv-group=".group" style="text-align:right;"></money>
                            </div>
                            <div class="col-sm-2 col-md-3 col-lg-3">
                                <label for="edtotaljurosbaixa">Total juros</label>
                                <money class="form-control form-control-sm" id="edtotaljurosbaixa" v-bind="money" v-model="vvariaveisbaixarcmp.vtotjurosbaixa" data-bv-group=".group" style="text-align:right;" disabled></money>
                            </div>
                            <div class="col-sm-2 col-md-3 col-lg-3">
                                <label for="edvalorpagarbaixa">Valor a pagar</label>
                                <money class="form-control form-control-sm" id="edvalorpagarbaixa" v-bind="money" v-model="vvariaveisbaixarcmp.vtotpagarbaixa" data-bv-group=".group" style="text-align:right; color: #337ab7; font-weight: bold;" disabled></money>
                            </div>
                            <div class="col-sm-2 col-md-3 col-lg-3">
                                <label for="edpercdescmultabaixa">Desc. Multa(%)</label>
                                <money class="form-control form-control-sm" id="edpercdescmultabaixa" v-bind="money" v-model="percdescontomulta" data-bv-group=".group" style="text-align:right;"></money>
                            </div>
                            <div class="col-sm-2 col-md-3 col-lg-3">
                                <label for="edvldesctomultabaixa">Vl. Multa</label>
                                <money class="form-control form-control-sm inputs-valores" id="edvldesctomultabaixa" v-bind="money" v-model="valdescontomulta" data-bv-group=".group" style="text-align:right;"></money>
                            </div>

                            <div class="col-sm-12 col-md-6 col-lg-6" id="dvformaspagto">
                                <span class="lblselect2">Forma de pagamento:</span>
                                <select id="cbformapagamentobaixa" v-model="vidformapagamentobaixa" data-placeholder="Selecione uma opção" data-allow-clear="true" style="width:100%; font-weight: bold;"></select>
                            </div>
                            <div class="col-sm-2 col-md-3 col-lg-3" id="dvvalorrecebimento">
                                <label for="edvalorrecebimento">Valor do recebimento</label>
                                <money class="form-control form-control-sm inputs-valores" id="edvalorrecebimento" v-bind="money" v-model="vvariaveisbaixarcmp.vvalorrecebimento" data-bv-group=".group" style="text-align:right;"></money>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="ednrvendaformabaixa">Nr. Venda:</label>
                                <input type="text" class="form-control form-control-sm" id="ednrvendaformabaixa" v-model="vnrvendaforma" maxlength="11" style="font-weight: bold;" v-mask="'###########'" v-bind:disabled="parseInt(vabatecredito) === 0">									
						    </div>                            
                            <div class="col-sm-12 col-md-1 col-lg-1">
                                <button type="button" id="btincforma" @click.prevent="mtdincforma()" class="btn btn-primary btn-sm" style="width:100%; margin-top:22px;"><i class="fa fa-plus"></i></button>
                            </div>
                            <div class="row"></div>
                            <div class="col-lg-12">
                                <div class="table-responsive" style="margin-top: 10px;">
                                    <table id="tbformaspagamento" class="table table-striped table-bordered table-hover table-sm responsive" style="margin-top: 10px">
                                        <thead class="thead-dark">
                                            <tr>
                                                <th width="50">Código:</th>
                                                <th width="200">Descrição:</th>
                                                <th width="100">Valor:</th>
                                                <th width="100">Perfil fluxo:</th>
                                                <th width="10" style="text-align: center;">Ação:</th>
                                            </tr>
                                        </thead>
                                        <tbody id="tbyformasbaixa">
                                            <tr v-for="(forma, index) in lstformasreceber" v-bind:key="index">
                                                <td>{{ mtdformatarzeros(forma.id, 2) }}</td>
                                                <td>{{ forma.descforma }}</td>
                                                <td style="text-align: right;">{{ formatavalor(forma.valor, 2) }}</td>
                                                <td><i class="fa fa-edit icon-editar-perfil" title="Alterar perfil do fluxo" @click.prevent="mtdalterarperfilfluxo(forma, index)"></i>{{ forma.descperfilfluxo }}</td>
                                                <td style="text-align: center;"><a class="btn btn-danger btn-sm"  href="#" @click.prevent="mtddelformas(forma)"><i class="fa fa-trash"></i></a></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-12">
                                <label for="txtobs">Observações</label>
                                <textarea class="form-control center" rows="2" v-model="obsbaixatit" id="txtobs" style="text-transform: uppercase;"></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <div class="container" style="padding-left: 0px; padding-right: 0px;">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="alert alert-success alerta-cashback text-center" v-show="parseFloat(vltotalcashback) > 0">
                                        <strong>CASHBACK DISPONÍVEL R$ {{ formatavalor(vltotalcashback, 2) }}!</strong>
                                    </div>                                    
                                </div>
                                <div class="col-sm-12 col-md-6 col-lg-6">
                                    <ul class="list-group">
                                        <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 5px;">
                                            <strong style="color: #666666;">Total do recebimento</strong>
                                            <span class="badge badge-primary badge-pill" style="font-size: 15px; background-color: #0acf97; width: 100px; text-align: right;">{{ formatavalor(vvltotalrecebimento, 2) }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-sm-12 col-md-4 col-lg-4">
                                    <a href="#" role="button" class="btn btn-success btn-sm" data-toggle="modal" id="btbaixartitulo" @click.prevent="mtdconfirmarbaixa()" name="btbaixartitulo" style="width:100%; margin-top: 2px;"><i class="fa fa-check"></i> Confirmar baixa dos títulos</a>
                                </div>
                                <div class="col-sm-12 col-md-2 col-lg-2">
                                    <a href="#" class="btn btn-secondary btn-sm" role="button" data-dismiss="modal" style="width:100%; margin-top: 2px;"><i class="fa fa-close"></i> Cancelar</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="mdlalterarperfilfluxo">
            <div class="modal-dialog modal-sm modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h6 class="modal-title" style="font-size: 14px;">Alteração de perfil do fluxo...</h6>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <span class="lblselect2">Perfil do fluxo:</span>
                            <select id="cbperfilfluxo" v-model="aidperfilfluxo" data-placeholder="Selecione um perfil" data-allow-clear="true" style="width:100%;">
                            </select>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-sm btn-primary"   data-dismiss="modal" @click.prevent="mtdconfirmarperfilfluxo()"><i class="fa fa-check"></i> Confirmar</button>
                    <button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
                </div>
                
            </div>
            </div>
        </div>                
    </div>
</template>
<script>
	import util from '../utilitarios/util.js'
	export default {
        name : "cmpbaixartitulosreceber",
        props: [
            'vdtbaixa',
            'vclientebaixa',
            'vidclientebaixa',
            'vvariaveisbaixarcmp',
            'propvaldescontojuros',
            'propvaldescontomulta',
            'proplstselecionados',
            'propidlancamentopdv',
            'propidpdv'
        ],       			
		data : function () {
			return {
                utodasfiliais 		    : this.$store.state.usuario.todasfiliais,
                vcodfilbaixa            : null,
                vfatorcreditoutilizar   : 0,
                vidformapagamentobaixa  : null,

				vtipoforma			    : 0,
				vespecieforma		    : 0,
				vabatecredito		    : 0,
				vnrvendaforma		    : '',                

                percdescontojuros       : 0,
                percdescontomulta       : 0,
                valdescontojuros        : 0,
                valdescontomulta        : 0,
                lstformasreceber        : [],
                vvltotalrecebimento     : 0,
                vtotalformas            : 0,
                vcompararecebimento     : 0,
                obsbaixatit             : '',

                vidperfilfluxoforma     : 0,
                vdescperfilfluxoforma   : '',         

                //alteração perfil fluxo
                aindiceperfilfluxo      : 0,
                aidperfilfluxo          : 0,
                adescperfilfluxo        : '',

                //variáveis para visualização do cashback
				vltotalcashback 		: 0,

                money: {
                    decimal: ',',
                    thousands: '.',
                    prefix: '',     //aqui colocar o cifrão se for necessário
                    precision: 2,
                    masked: false
                }                
            }
         },
		methods: {
			formatavalor(valor, digitos){
				return util.formatavalordecimais(valor, digitos);
            },
            arredondavalores(val, casas) {
                return util.arredondaValores( val, casas, 'round' );
            },
			mtdformatarzeros(str, length){
				return util.formatarzeros(str, length);
			},                        
            mtdiniciar_def_cmp_btr(){
                let vself         = this;
				let sqliniusuario = parseInt(vself.utodasfiliais) === 0 ? 'select f.codfil, f.fantasia from tbfiliaisusuario fu left join tbfiliais f on f.codfil=fu.idfilial ' : 'select codfil, fantasia from tbfiliais ';
                let sqlfimusuario = parseInt(vself.utodasfiliais) === 0 ? 'where upper(f.fantasia) like upper("%@@%") and fu.idusuario='+vself.$store.state.usuario.id 		 : 'where upper(fantasia) like upper("%@@%")';                                

                $("#cbfilialbaixarec").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
                    }
                ).change(function (){
                    vself.vcodfilbaixa = $("#cbfilialbaixarec").val();
                    if (vself.vcodfilbaixa != null) {
                        let loader      = vself.$loading.show();
                        let parametros  = [
                            {parametro: 'op',           valor : 'listagem'},
                            {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                            {parametro: 'filtro',       valor : ' and f.codfil='+vself.vcodfilbaixa},
                            {parametro: 'limit',        valor : 1},
                            {parametro: 'offset',       valor : 0},
                        ];
                        let retorno          = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadfiliais.php');
                        retorno.then(function (response) {
                            vself.vfatorcreditoutilizar = parseFloat(response.data[0].fatorcreditoutilizar); 
                            loader.hide();
                        }).catch(function (response) {
                            loader.hide();
                        });
                    } else {//quando limpa seleção
                        vself.vfatorcreditoutilizar = 0;
                    }                    
                });
				$("#cbformapagamentobaixa").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbformaspagamento',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidformapagamentobaixa = $("#cbformapagamentobaixa").val();
                    vself.vnrvendaforma          = '';
                    if (vself.vidformapagamentobaixa !== null && parseInt(vself.propidpdv) > 0){
                        let loader      = vself.$loading.show();
                        let filtro      = ' where pf.idpdv='+vself.propidpdv+' and pf.idforma='+vself.vidformapagamentobaixa;
                        let parametros  = [
                            {parametro: 'op',           valor : 'perfilformapdv'},
                            {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                            {parametro: 'filtro',       valor : filtro}
                        ];
                        let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/auxiliares.php');
                        retorno.then(function (response) {
                            loader.hide();	
                            vself.vtipoforma            = parseInt(response.data[0].tipo); 
							vself.vespecieforma         = parseInt(response.data[0].especie);
							vself.vabatecredito         = parseInt(response.data[0].abatecredito); 
                            vself.vidperfilfluxoforma   = parseInt(response.data[0].idperfilfluxo) === 0 ? null : response.data[0].idperfilfluxo;                
                            vself.vdescperfilfluxoforma = response.data[0].descperfilfluxo;
                        }).catch(function (response) {
                            vself.vtipoforma = 0;
                            vself.vespecieforma = 0;
                            vself.vabatecredito = 0;
                            vself.vidperfilfluxoforma   = 0;                
                            vself.vdescperfilfluxoforma = '';                            
                            loader.hide();
                        });
                    }
                    setTimeout(() => {
                        if (vself.vidformapagamentobaixa !== null){
                            let loader      = vself.$loading.show();
                            let filtro      = ' and f.id='+vself.vidformapagamentobaixa;
                            let parametros  = [
                                {parametro: 'op',           valor : 'listagem'},
                                {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                                {parametro: 'filtro',       valor : filtro},
                                {parametro: 'limit',        valor : "99999999999"},
                                {parametro: 'offset',       valor : "0"}
                            ];
                            let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadformaspagamento.php');
                            retorno.then(function (response) {
                                loader.hide();	
                                vself.vtipoforma            = parseInt(response.data[0].tipo); 
                                vself.vespecieforma         = parseInt(response.data[0].especie);
                                vself.vabatecredito         = parseInt(response.data[0].abatecredito); 			                            						


                                if (parseInt(vself.vabatecredito) === 1){//localiza o crédito quando houver
                                    let loader      = vself.$loading.show();
                                    let filtro      = ' and p.stpedido=1 and p.tipo=3 and p.idcliente='+vself.vidclientebaixa;
                                    let parametros  = [
                                        {parametro: 'op',           	valor : 'listagem'},
                                        {parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgpedidos+vself.$store.state.filialpadrao.idcliente},
                                        {parametro: 'idclientesac', 	valor  : vself.$store.state.filialpadrao.idcliente},
                                        {parametro: 'filtro',       	valor : filtro},
                                        {parametro: 'limit',        	valor : 1},
                                        {parametro: 'offset',       	valor : 0},
                                    ];
                                    let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
                                    retorno.then(function (response) {
                                        loader.hide();
                                        if (response.data.pedidos.length > 0){
                                            vself.vltotalcashback   = parseFloat(response.data.pedidos[0].vlcredito) - parseFloat(response.data.pedidos[0].vlcreditoutilizado);
                                            vself.vnrvendaforma     = response.data.pedidos[0].id;
                                        }
                                    }).catch(function (response) {
                                        console.log(response);
                                        vself.$toastr.e('Erro ao tentar carregar dados da venda!', 'Erro!');						
                                        $('#cbformapagamento').focus();
                                        loader.hide();
                                    });
                                }                                

                            }).catch(function (response) {
                                vself.vtipoforma    = 0;
                                vself.vespecieforma = 0;
                                vself.vabatecredito = 0;
                                loader.hide();
                            });                                     
                        }                        
                    }, 300);
                    
                });
                $("#cbperfilfluxo").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbperfisfluxocaixa',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.aidperfilfluxo = $("#cbperfilfluxo").val();
                });                                
            },
            mtdincforma() {
                let vself = this;

				if (parseInt(vself.vabatecredito) === 1 && vself.vnrvendaforma === ''){
					vself.$toastr.w('Informe o número da venda para o resgate!', 'Informação!');
					$('#ednrvendaformabaixa').focus();
					return;					
				}

				if (parseInt(vself.vabatecredito) === 1){
					let vllimitecreditoabater = util.arredondaValores( parseFloat(vself.vfatorcreditoutilizar) * parseFloat(vself.vvariaveisbaixarcmp.vtotpagarbaixa) / 100, 2, 'round');				
					if (parseInt(parseFloat(vself.vvariaveisbaixarcmp.vvalorrecebimento) * 100) > parseInt(parseFloat(vllimitecreditoabater) * 100)){
						vself.$toastr.w('O valor permitido para uso do crédito/cashback não pode ultrapassar '+util.formatavalordecimais(vllimitecreditoabater, 2)+' ('+vself.vfatorcreditoutilizar+'%). Verifique e tente novamente!', 'Informação!');
						return;						
					}
				}

                if(vself.percdescontojuros > 100 || vself.percdescontojuros < 0){
                    vself.$toastr.w('Informe valor entre 0 (zero) e 100 (cem) %.', 'Atenção!');
                    $("#edpercdesctojurosbaixa").focus();
                    return;
                }
                if(vself.percdescontomulta > 100 || vself.percdescontomulta < 0){
                    vself.$toastr.w('Informe valor entre 0 (zero) e 100 (cem) %.', 'Atenção!');
                    $("#edpercdescmultabaixa").focus();
                    return;
                }

                if(vself.valdescontojuros > vself.vvariaveisbaixarcmp.vtotjurosbaixa){
                    vself.$toastr.w('Informe um valor menor ou igual ao total do juros!', 'Atenção!');
                    $("#edvldesctojurosbaixa").focus();
                    return;
                }
                if(vself.valdescontomulta > vself.vvariaveisbaixarcmp.vtotmultabaixa){
                    vself.$toastr.w('Informe um valor menor ou igual ao total da multa!', 'Atenção!');
                    $("#edvldesctomultabaixa").focus();
                    return;
                }
                if(vself.vvariaveisbaixarcmp.vvalorrecebimento <= 0){
                    vself.$toastr.w('Informe um valor válido para a forma de pagamento!', 'Atenção!');
                    $('#edvalorrecebimento').focus();
                    return;
                }
                vself.vcompararecebimento = 0;
                vself.vcompararecebimento = vself.arredondavalores(vself.vvariaveisbaixarcmp.vvalorrecebimento + vself.vvltotalrecebimento, 2);
                if(vself.vcompararecebimento > vself.arredondavalores(vself.vvariaveisbaixarcmp.vtotpagarbaixa,2)){
                    vself.$toastr.w('Total a receber já informado abaixo para as formas de pagamento!', 'Atenção!');
                    $('#edvalorrecebimento').focus();
                    return;
                }

                if (vself.vnrvendaforma === ''){//caso não seja resgate	
                    let formasrec = {
                        'id'             : vself.vidformapagamentobaixa,
                        'descforma'      : $('#cbformapagamentobaixa').select2('data')[0]['text'],
                        'tipo'           : 0,      //COLOCAR DEPOIS AQUI O TIPO SE É AVISTA OU A PRAZO
                        'valor'          : vself.vvariaveisbaixarcmp.vvalorrecebimento,
                        'nrvenda'		 : vself.vnrvendaforma,
                        'idperfilfluxo'  : vself.vidperfilfluxoforma,
                        'descperfilfluxo': vself.vdescperfilfluxoforma
                    };

                    if (!util.findValInArray(vself.lstformasreceber, 'id', formasrec.id)){
                        vself.lstformasreceber.push(formasrec);
                        vself.vtotalformas   = vself.vtotalformas + vself.vvariaveisbaixarcmp.vvalorrecebimento;
                    }else{
                        vself.$toastr.w('Forma de pagamento já inclusa!', 'Atenção!');
                        $('#cbformapagamentobaixa').focus();
                        return false;
                    }

                    vself.vvltotalrecebimento                   = vself.vtotalformas;
                    vself.vvariaveisbaixarcmp.vvalorrecebimento = (vself.valdescontojuros + vself.valdescontomulta + vself.vvariaveisbaixarcmp.vtottitbaixa) - (vself.vvltotalrecebimento);
                    $('#cbformapagamentobaixa').focus();
                }else{
					let loader      = vself.$loading.show();
					let filtro      = ' and p.stpedido=1 and p.id='+vself.vnrvendaforma;
					let parametros  = [
						{parametro: 'op',           valor : 'listagem'},
						{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgpedidos+vself.$store.state.filialpadrao.idcliente},
						{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'filtro',       valor : filtro},
						{parametro: 'limit',        valor : 1},
						{parametro: 'offset',       valor : 0},
					];
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
					retorno.then(function (response) {
						loader.hide();
                        if (response.data.pedidos.length > 0){
							if (parseInt(response.data.pedidos[0].creditoindividual) === 1){//caso o crédito for individual
								if (parseInt(response.data.pedidos[0].idcliente) !== parseInt(vself.vidclientebaixa)){//verifica se o cliente é o titular do crédito. caso não for não libera
									vself.$toastr.i('O crédito em questão só pode ser utilizado pelo cliente titular!', 'Informação!');
									return;
								}
							}

							let vlcreditodisp = parseFloat(response.data.pedidos[0].vlcredito) - parseFloat(response.data.pedidos[0].vlcreditoutilizado);
							if (vself.vvariaveisbaixarcmp.vvalorrecebimento > vlcreditodisp){
								vself.$toastr.i('Valor do crédito desta venda não é suficiente ou não está disponível para resgate!', 'Informação!');
								$('#cbformapagamentobaixa').select2('open');
								return;
							}else{
                                let formasrec = {
                                    'id'             : vself.vidformapagamentobaixa,
                                    'descforma'      : $('#cbformapagamentobaixa').select2('data')[0]['text'],
                                    'tipo'           : 0,      //COLOCAR DEPOIS AQUI O TIPO SE É AVISTA OU A PRAZO
                                    'valor'          : vself.vvariaveisbaixarcmp.vvalorrecebimento,
                                    'nrvenda'		 : vself.vnrvendaforma,
                                    'idperfilfluxo'  : vself.vidperfilfluxoforma,
                                    'descperfilfluxo': vself.vdescperfilfluxoforma
                                };

                                if (!util.findValInArray(vself.lstformasreceber, 'id', formasrec.id)){
                                    vself.lstformasreceber.push(formasrec);
                                    vself.vtotalformas   = vself.vtotalformas + vself.vvariaveisbaixarcmp.vvalorrecebimento;
                                }else{
                                    vself.$toastr.w('Forma de pagamento já inclusa!', 'Atenção!');
                                    $('#cbformapagamentobaixa').focus();
                                    return false;
                                }

                                vself.vvltotalrecebimento                   = vself.vtotalformas;
                                vself.vvariaveisbaixarcmp.vvalorrecebimento = (vself.valdescontojuros + vself.valdescontomulta + vself.vvariaveisbaixarcmp.vtottitbaixa) - (vself.vvltotalrecebimento);
                                $('#cbformapagamentobaixa').focus();
                            }                            
                        }else{
							vself.$toastr.w('Venda não encontrada/cancelada no sistema. Verifique corretamente se a venda permite que o crédito seja resgatado e tente novamente!', 'Informação!');
							$('#ednrvendaformabaixa').focus();
						}
                    }).catch(function (response) {
						console.log(response);
						vself.$toastr.e('Erro ao tentar carregar dados da venda!', 'Erro!');						
						$('#cbformapagamentobaixa').focus();
						loader.hide();
					});                                        
                }
            },
            mtddelformas(forma) {
                this.vvariaveisbaixarcmp.vvalorrecebimento = this.vvariaveisbaixarcmp.vvalorrecebimento + forma.valor;
                this.vvltotalrecebimento                   = this.vvltotalrecebimento - forma.valor;
                this.vtotalformas                          = this.vtotalformas - forma.valor;

                this.lstformasreceber.splice(util.getArrayIndexForKey(this.lstformasreceber, 'id', forma.id), 1);
                this.resetaValor;
                $('#cbformapagamentobaixa').focus();
            },
            mtdconfirmarbaixa() {
                let vself = this;
                if (vself.vcodfilbaixa === null){
                    vself.$toastr.w('Filial da baixa do título deve ser informada!', 'Atenção!');
                    $("#cbfilialbaixarec").focus();
                    return;
                }
                //verifica o percentual do juros e da multa para baixa
                if (vself.percdescontojuros > vself.$store.state.usuario.descontojuros){
                    vself.$toastr.w('Percentual de desconto no juros não permitido para o seu perfil de usuário!', 'Atenção!');
                    return;
                }
                if (vself.percdescontomulta > vself.$store.state.usuario.descontomulta){
                    vself.$toastr.w('Percentual de desconto na multa não permitido para o seu perfil de usuário!', 'Atenção!');
                    return;
                }
                //////////////////////////////////////////////////////
                if (vself.vvltotalrecebimento > 0){
                    $.confirm({
                        title: 'Confirmação!',
                        content: 'Confirma baixa do(s) título(s)?',
                        icon: 'fa fa-question-circle',
                        escapeKey: true,
                        backgroundDismiss: false,
                        escapeKey: 'nao',
                        type: 'dark',
                        typeAnimated: true,                        
                        buttons: {
                            sim: {
                                text : '<u>S</u>im',
                                keys: ['s', 'S'],
                                btnClass: 'btn-blue',
                                action: function () {
                                    $('.btn-blue').prop('disabled', true);
                                    vself.mtdbaixar();
                                },
                            },
                            nao: {
                                text: '<u>N</u>ão',
                                keys: ['n', 'N'],
                                action: function () {
                                    $("#cbformapagamentobaixa").focus();
                                }
                            }
                        }
                    });
                }else{
                    vself.$toastr.w('Informe um valor válido para o pagamento!', 'Atenção!');
                    $("#cbformapagamentobaixa").focus();
                }
            },
            mtdbaixar(){
                let vself  = this;
                let loader = vself.$loading.show();
                let dadosbaixa = {
                    'dtbaixa'               : vself.vdtbaixa,
                    'idclientebaixa'        : vself.vidclientebaixa,
                    'percdescontojuros'     : vself.percdescontojuros,
                    'percdescontomulta'     : vself.percdescontomulta,
                    'vltotalrecebimento'    : vself.vvltotalrecebimento,
                    'obsbaixatit'           : vself.obsbaixatit,
                    'titulosbaixar'         : vself.proplstselecionados,
                    'idfilialbaixa'         : vself.vcodfilbaixa,
                    'formas'                : vself.lstformasreceber,
                    'idlancamentopdv'       : vself.propidlancamentopdv,
                    'idpdv'                 : vself.propidpdv
                };
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'baixar'},
                    {parametro: 'dadosbaixa',   valor : JSON.stringify(dadosbaixa)},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : '030Z.010Z.040Z'}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtitulosreceberv2.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data.ret)){
                        $('#mdBaixarTitulosReceber').modal('hide');
                        vself.$toastr.s('Títulos baixados com sucesso!', 'Informação!');
                        //dispara a mutation pra executar a pesquisa do resultado da baixa
                        let payload = {
                            retorno    : parseInt(vself.propidlancamentopdv) === 0 ? 1 : response.data.ret
                        };
                        vself.$store.commit('RETORNO_BAIXA_RECEBER_CHANGE',payload);                        
                    }else{
                        let tpret = response.data.ret.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.ret.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.ret.substring(4), 'Erro!');
                                break;
                        }
                    }                    
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                    $('#mdBaixarTitulosReceber').modal('hide');
                });                                
            },
            mtdalterarperfilfluxo(forma, indice){
                this.aindiceperfilfluxo  = indice;
                this.aidperfilfluxo      = forma.idperfilfluxo;
                this.adescperfilfluxo    = forma.descperfilfluxo;
                if (parseInt(this.aidperfilfluxo) !== 0){
                    var deffluxo  = new Option(this.adescperfilfluxo, this.aidperfilfluxo, true, true);
                    $('#cbperfilfluxo').append(deffluxo).trigger('change');
                }else{
                    $('#cbperfilfluxo').val(null).trigger('change');
                }

                $('#mdlalterarperfilfluxo').modal('show');
            },
            mtdconfirmarperfilfluxo(){
                this.lstformasreceber[this.aindiceperfilfluxo].idperfilfluxo   = this.aidperfilfluxo === null ? 0 : this.aidperfilfluxo;
                this.lstformasreceber[this.aindiceperfilfluxo].descperfilfluxo = this.aidperfilfluxo === null ? '' : $('#cbperfilfluxo').select2('data')[0]['text'];
                $('#mdlalterarperfilfluxo').modal('hide');
            },
			mtdvisualizarcashback(){
				let vself = this;
				let loader      = vself.$loading.show();
				let filtro      = ' and p.stpedido=1 and p.tipo=3 and p.idcliente='+vself.vidclientebaixa;
				let parametros  = [
					{parametro: 'op',           	valor : 'listagem'},
					{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgpedidos+vself.$store.state.filialpadrao.idcliente},
					{parametro: 'idclientesac', 	valor  : vself.$store.state.filialpadrao.idcliente},
					{parametro: 'filtro',       	valor : filtro},
					{parametro: 'limit',        	valor : 1},
					{parametro: 'offset',       	valor : 0},
				];
				let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
				retorno.then(function (response) {
					loader.hide();
					if (response.data.pedidos.length > 0){
						vself.vltotalcashback 			= parseFloat(response.data.pedidos[0].vlcredito) - parseFloat(response.data.pedidos[0].vlcreditoutilizado)
					}
				}).catch(function (response) {
					console.log(response);
					vself.$toastr.e('Erro ao tentar carregar dados da venda!', 'Erro!');						
					$('#cbformapagamento').focus();
					loader.hide();
				});	
			}                                                
        },
        mounted: function () { 
            let vself = this;
            $("#mdBaixarTitulosReceber").on('show.bs.modal', function () {
                //limpa variaveis
                vself.percdescontojuros     = 0;
                vself.percdescontomulta     = 0;
                vself.lstformasreceber      = [];
                vself.vvltotalrecebimento   = 0;
                vself.vtotalformas          = 0;
                vself.vcompararecebimento   = 0;
                vself.vidformapagamentobaixa= null;
                vself.vltotalcashback       = 0;

                var deffilialbaixa = new Option(vself.$store.state.filialpadrao.fantasia, vself.$store.state.filialpadrao.codfil, true, true);
                $('#cbfilialbaixarec').append(deffilialbaixa).trigger('change');

                $("#cbformapagamentobaixa").val(null).trigger('change');
                setTimeout(() => {
                    vself.mtdvisualizarcashback();
                }, 500);                
            });
            $("#mdBaixarTitulosReceber").on('shown.bs.modal', function () {
                $("#edpercdesctojurosbaixa").focus();
            });
            $('#edvldesctojurosbaixa').blur(function(){
                let rValorJuros       = 0;
                let rPercDesc         = 0;
                rValorJuros           = vself.valdescontojuros;

                if(vself.vvariaveisbaixarcmp.vtotjurosbaixa > 0)
                {
                    rPercDesc          = (1 - (rValorJuros / vself.vvariaveisbaixarcmp.vtotjurosbaixa)) * 100;
                }else{
                    rPercDesc          = 0;
                }
                vself.percdescontojuros                     = rPercDesc;
                vself.vvariaveisbaixarcmp.vvalorrecebimento = vself.valdescontojuros + vself.valdescontomulta + vself.vvariaveisbaixarcmp.vtottitbaixa;
            });
            $('#edvldesctomultabaixa').blur(function(){
                let rValorMulta       = 0;
                let rPercDesc         = 0;
                rValorMulta           = vself.valdescontomulta;

                if(vself.vvariaveisbaixarcmp.vtotmultabaixa > 0)
                {
                    rPercDesc          = (1 - (rValorMulta / vself.vvariaveisbaixarcmp.vtotmultabaixa)) * 100;
                }else{
                    rPercDesc          = 0;
                }
                vself.percdescontomulta                     = rPercDesc;
                vself.vvariaveisbaixarcmp.vvalorrecebimento = vself.valdescontojuros + vself.valdescontomulta + vself.vvariaveisbaixarcmp.vtottitbaixa;
            });                         

            $("#mdlalterarperfilfluxo").on('show.bs.modal', function(){
                $('#cbperfilfluxo').select2('open');
            });            
            this.mtdiniciar_def_cmp_btr();     
        },
        computed: {
            resetaValor() {
                if(this.lstformasreceber.length === 0) {
                    this.vvariaveisbaixarcmp.vvalorrecebimento = 0;
                    this.vvariaveisbaixarcmp.vvalorrecebimento = this.valdescontojuros + this.valdescontomulta + this.vvariaveisbaixarcmp.vtottitbaixa;
                }
            }            
        },
        watch:{
            percdescontojuros() {
                let rJuros                                 = 0;
                rJuros                                     = this.vvariaveisbaixarcmp.vtotjurosbaixa * (1-(this.percdescontojuros/100));
                this.valdescontojuros                      = rJuros;
                this.vvariaveisbaixarcmp.vvalorrecebimento = this.valdescontojuros + this.valdescontomulta + this.vvariaveisbaixarcmp.vtottitbaixa;
            },
            propvaldescontojuros() {
                this.valdescontojuros = this.propvaldescontojuros;
            },
            propvaldescontomulta() {
                this.valdescontomulta = this.propvaldescontomulta;
            },
            percdescontomulta() {
                let rMulta                                 = 0;
                rMulta                                     = this.vvariaveisbaixarcmp.vtotmultabaixa * (1-(this.percdescontomulta/100));
                this.valdescontomulta                      = rMulta;
                this.vvariaveisbaixarcmp.vvalorrecebimento = this.valdescontojuros + this.valdescontomulta + this.vvariaveisbaixarcmp.vtottitbaixa;
            }            
        }
	}
</script>
<style>
</style>